// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__KPGwr","icon":"SortAdornment_icon__1vodp","up":"SortAdornment_up__1IRm6","down":"SortAdornment_down__3TCon","active":"SortAdornment_active__gOTMV"};